import { render, staticRenderFns } from "./BotonesNavegacion.vue?vue&type=template&id=0a26e589&scoped=true"
import script from "./BotonesNavegacion.vue?vue&type=script&lang=js"
export * from "./BotonesNavegacion.vue?vue&type=script&lang=js"
import style0 from "./BotonesNavegacion.vue?vue&type=style&index=0&id=0a26e589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26e589",
  null
  
)

export default component.exports